module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/InsightIncident2-2b13333316055d9065ab23a26a34962e.jpg";